import React from 'react';

function Icon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path d="M8.85588 5.25262L11.9779 10.4879C12.2607 10.9622 12.1055 11.5761 11.6312 11.8589C11.4763 11.9513 11.2993 12.0001 11.119 12.0001H4.875C4.32272 12.0001 3.875 11.5523 3.875 11.0001C3.875 10.8197 3.92376 10.6427 4.01612 10.4879L7.13812 5.25262C7.421 4.77827 8.03484 4.62305 8.50918 4.90593C8.65173 4.99093 8.77087 5.11008 8.85588 5.25262Z" />
    </svg>
  );
}

export default Icon;
